import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Button } from '@aimsos/ui';
import { AlertTriangle } from 'lucide-react';

/**
 * Said when the lists the form offers (locations, industries, cities) could not
 * be loaded. Without it the selects are just empty and a required one cannot be
 * filled, with nothing to say why or what to do.
 */
function OptionsLoadError({ onRetry }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-red-400/40 bg-red-500/10 p-3"
    >
      <p className="flex items-center gap-2 text-sm text-content">
        <AlertTriangle className="size-4 shrink-0 text-red-500" aria-hidden />
        {t('create.options.error')}
      </p>
      <Button variant="secondary" size="sm" onClick={onRetry}>
        {t('create.options.retry')}
      </Button>
    </div>
  );
}

export default memo(OptionsLoadError);
